import axiosClient from "./axiosClient";

export async function getCarouselAdvertisements() {
  const response = await axiosClient.get("/advertisements/carousel");
  return response.data;
}

export async function trackAdvertisementEvent(id, eventType) {
  return axiosClient
    .post(`/advertisements/${id}/track`, { eventType, platform: "web" })
    .catch(() => {});
}
